<!-- FIXME: mockと同じ構成のHTMLに修正する -->
<template>
  <div class="c-form-select -type2 -homework">
    <div>
      <label>
        <select
          v-model="proxyValue"
          @change="emit('change')"
          class="resettableSelectBox"
          :class="{ 'resettable-select-single-disabled': isDisabled }"
          tabindex="0"
          name="resettable"
          :disabled="isDisabled"
        >
          <option v-if=initLabel value="" disabled hidden>{{ labelName }}</option>
          <option v-if=ResetOption value=""></option>
          <option
            v-for="option in options"
            :key="option.value"
            :value="option.value"
          >{{ option.name }}</option>
        </select>
      </label>
    </div>
  </div>
</template>

<script setup lang="ts">
  import {computed} from "vue";
  import { ISelectSingleOption } from "@/consts/interfaces";

  const props = withDefaults(
    defineProps<{
      selected: number | string;
      title?: string;
      options: ISelectSingleOption[];
      wide?: boolean;
      initLabel?: boolean;
      isDisabled?: boolean;
      ResetOption?: boolean;
      labelName?: string;
    }>(),
    {
      title: "",
      wide: false,
      initLabel: false,
      isDisabled: false,
      ResetOption: false,
      labelName: ""
    }
  )
  const emit = defineEmits<{
    (e: "update:selected", value: number | string): void;
    (e: "change"): void;
  }>()
  const proxyValue = computed({
    // getter
    get(){
      return props.selected
    },
    set(newValue){
      emit('update:selected', newValue)
    }
  })
</script>

<style lang="scss" scoped>
  // FIXME: optionsにmockのCSSを当てられるように変更する
.resettableSelectBox {
  appearance: auto;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 0 9px 0 #cad2de;
  cursor: pointer;
  font-family: inherit;
  font-weight: 700;
  height: 44px;
  padding: 0 1em;
  width: calc(100% - 4px);
}
.resettable-select-single-disabled {
  pointer-events: none;
}
</style>
